"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.querySlugKey = exports.queryIteratorPath = exports.query = void 0;
var query = "\n  query {\n    allFishermanBusinessTeam(filter: { show: { eq: true } }) {\n      nodes {\n        _id\n        name\n      }\n    }\n  }\n";
exports.query = query;
var queryIteratorPath = ['allFishermanBusinessTeam', 'nodes'];
exports.queryIteratorPath = queryIteratorPath;
var querySlugKey = 'name';
exports.querySlugKey = querySlugKey;